import React, { Component, Fragment } from 'react';

import './styles.css';

import eyeClosedIcon from '../../../assets/svg/eye_closed.svg';
import eyeIcon from '../../../assets/svg/eye.svg';

/**
 * An input with a floating label.
 *
 * @typedef {HTMLInputElement|Object} Props
 * @prop {String} name
 * @prop {String} label
 * @prop {String} type
 * @prop {String} [value]
 *
 * @augments {Component<Props>}
 */
export default class Input extends Component {

	state = {
		animate: false,
		animateTimes: 0,
		initialType: this.props.type,
		type: this.props.type || 'text',
		value: this.props.value || '',
	};

	handleTogglePassVisibility = () => {
		const type = this.state.type === 'text' ? 'password' : 'text';
		this.setState({ type });
	}

	handleInput = (event) => {
		this.setState({ value: event.currentTarget.value });
		if (this.props.onInput) this.props.onInput(event);
	};

	handleFocus = () => {
		this.setState({ animate: true });
		setTimeout(() => {
			this.setState({ animate: false, animateTimes: 1 });
		}, 1500);
	}

	handleBlur = () => this.setState({ animate: false, animateTimes: 1 });

	render () {
		const { label, innerRef, animated, ...inputProps } = this.props;
		const { animate, animateTimes, value, type, initialType } = this.state;
		const showPassImage = type === 'text' ? eyeClosedIcon : eyeIcon;

		return (
			<label className={`Input ${animate && animateTimes === 0 ? 'focused' : ''}`}>
				{
					type === 'textarea'
						? <textarea
							onChange={this.handleInput}
							{...{ value, ...inputProps }}
							onFocus={this.handleFocus}
							onBlur={this.handleBlur}
						/>
						: <input
							{...inputProps}
							{...{ type, value }}
							className={initialType}
							onInput={this.handleInput}
							onChange={this.handleInput}
							onFocus={this.handleFocus}
							onBlur={this.handleBlur}
							ref={innerRef}
						/>
				}
				<span className='label'>{label}</span>
				{
					initialType === 'password'
						? <span className='togglePass' onClick={this.handleTogglePassVisibility}>
							<img src={showPassImage} alt='Toggle pass icon' />
						</span> : null
				}
				{animated ? <Fragment>
					<span className='animated' />
					<span className='animated' />
					<span className='animated' />
					<span className='animated' />
				</Fragment> : null}
				<div className='Input-validationBar' />
			</label>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/atoms/Input/Input.js